import * as React from "react"

import {
	DataTableBody,
	DataTableCellAlphaNumeric,
	DataTableRow,
} from "@walmart-web/livingdesign-components"
import { useIntl } from "react-intl"

import Table from "components/Transactional/SelloutReport/Table"
import Download from "components/Transactional/SelloutReport/ReportsTable/Download"
import { SelloutReportItem } from "components/Transactional/SelloutReport/service"
import "./index.scss"

interface Props {
	reports: SelloutReportItem[]
	setMessage: () => void
	setDisableDownload: (disableDownload: boolean) => void
	disableDownload: boolean
}

const DetailsRows: React.FC<Props> = ({
	reports,
	setMessage,
	setDisableDownload,
	disableDownload,
}) => {
	const intl = useIntl()
	return (
		<Table
			titleTranslationId={"phronesis.blank.space"}
			isFetching={false}
			className="intern-table"
		>
			<DataTableBody>
				{reports.map(({ filename, period }) => (
					<DataTableRow key={filename} UNSAFE_className="table-report-row">
						<DataTableCellAlphaNumeric UNSAFE_className="table-report-col-period">
							{period && (
								<span>
									{intl.formatMessage({
										id:
											"phronesis.sellout_report.application.reporting_sellout.table.period",
									})}{" "}
									{period}
								</span>
							)}
						</DataTableCellAlphaNumeric>
						<DataTableCellAlphaNumeric UNSAFE_className="table-report-col-filename">
							{filename}
						</DataTableCellAlphaNumeric>
						<DataTableCellAlphaNumeric UNSAFE_className="table-report-col-download">
							<Download
								filename={filename}
								setMessage={setMessage}
								setDisableDownload={setDisableDownload}
								disableDownload={disableDownload}
							/>
						</DataTableCellAlphaNumeric>
					</DataTableRow>
				))}
			</DataTableBody>
		</Table>
	)
}

export default DetailsRows
